// The fallback covers the first paint, before ui-kit's Sidebar writes the variable onto <html>.
export const SIDEBAR_OFFSET = "var(--ui-sidebar-width, 200px)";
